import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

export interface Props {
  onClose: () => void
  onSubmit: () => void
}

const DeleteModal = ({ onClose, onSubmit }: Props) => {
  return (
    <Modal
      onClose={onClose}
      onSubmit={onSubmit}
      illustration="delete-cross"
      title={i18n.t('time_planning.planning_versions.modal.delete.title')}
      description={i18n.t('time_planning.planning_versions.modal.delete.description')}
      footer={
        <Button submit>{i18n.t('time_planning.planning_versions.modal.delete.button')}</Button>
      }
    >
      <Box
        paddingX="s24"
        paddingY="s16"
        background="champagne400"
        borderRadius={{
          all: 'abs008',
        }}
      >
        <Text.Normal>{i18n.t('time_planning.planning_versions.modal.delete.warning')}</Text.Normal>
      </Box>
    </Modal>
  )
}

export default observer(DeleteModal)
